import { CheckboxInput } from '@framework/form/inputs/CheckboxInput.tsx';
import { DecimalInput } from '@framework/form/inputs/DecimalInput.tsx';
import { NumberInput } from '@framework/form/inputs/NumberInput.tsx';
import { TextInput } from '@framework/form/inputs/TextInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { MapLayerIntersectionAttributesInput } from './MapLayerIntersectionAttributesInput.tsx';

export interface IMapLayerIntersectionConfigInputProps {
  prefix: string;
}

/**
 * Configurazione intersezione per un singolo layer della mappa.
 */
export function MapLayerIntersectionConfigInput(
  props: IMapLayerIntersectionConfigInputProps,
) {
  const { prefix } = props;

  return (
    <>
      <FormItem label="Titolo" name={`${prefix}intersection.title`}>
        <TextInput name={`${prefix}intersection.title`} />
      </FormItem>
      <MapLayerIntersectionAttributesInput prefix={`${prefix}intersection.`} />
      <FormItem
        label="Tolleranza area (mq)"
        name={`${prefix}intersection.areaTolerance`}
        help="Area minima in metri quadri sotto la quale l'intersezione viene ignorata"
      >
        <DecimalInput name={`${prefix}intersection.areaTolerance`} min={0} />
      </FormItem>
      <FormItem
        label="Numero massimo risultati"
        name={`${prefix}intersection.maxResults`}
        help="Se specificato, limita il numero di righe nella tabella intersezioni"
      >
        <NumberInput name={`${prefix}intersection.maxResults`} min={1} />
      </FormItem>
      <FormItem label="" name={`${prefix}intersection.backofficeOnly`}>
        <CheckboxInput name={`${prefix}intersection.backofficeOnly`}>
          Visibile solo in Back Office
        </CheckboxInput>
      </FormItem>
    </>
  );
}
